import React, { useState } from "react";
import {
  CreateShoppingList,
  Discover,
  GetFeedback,
  InviteFriends,
} from "./Page2SVG";

const Page2Mobile = ({ sectionStyle }) => {
  const inviteFriend =
    process.env.PUBLIC_URL + "/assets/landingFinal/mobile/InviteFriends.png";
  const DiscoverImg =
    process.env.PUBLIC_URL + "/assets/landingFinal/Discover.png";
  const CreateShopListImg =
    process.env.PUBLIC_URL + "/assets/landingFinal/CreateShopList.png";
  const GetFeedbackImg =
    process.env.PUBLIC_URL + "/assets/landingFinal/GetFeedback.png";
  const [option, setOption] = useState("Discover Trends");
  const [borderColor, setBorderColor] = useState("#2596D1");
  const [bgrColor, setBgrColor] = useState("#DFF4FF");
  const [image, setImage] = useState(DiscoverImg);
  const Option = (SVG, text, bgColor, iconBgColor, img) => {
    return (
      <div
        onClick={() => {
          setOption(text);
          setBorderColor(iconBgColor);
          setImage(img);
          setBgrColor(bgColor);
        }}
        style={{
          backgroundColor: option === text ? bgColor : "",
          height: "92px",
          width: "100%",
          gap: "16px",
          padding: "12px 16px",
          borderRadius: "16px",
          cursor: "pointer",
        }}
        className="d-flex align-items-center"
      >
        <div
          style={{
            backgroundColor: option === text ? iconBgColor : "#F1F5F9",
            height: "52px",
            width: "52px",
            borderRadius: "12px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <SVG selected={option === text} />
        </div>
        <div
          style={{
            fontSize: "20px",
            fontWeight: option === text ? 600 : 500,
            color: "#000",
          }}
        >
          {text}
        </div>
      </div>
    );
  };
  return (
    <div
      style={{ ...sectionStyle, gap: "20px" }}
      className="d-flex flex-column align-items-center justify-content-center"
    >
      <div className="d-flex flex-column" style={{ gap: "12px" }}>
        <div className="d-flex flex-column" style={{ gap: "8px" }}>
          <div style={{ fontSize: "27px", fontWeight: "600", color: "#000" }}>
            Discover New Styles
          </div>
          <div
            style={{ fontSize: "16px", fontWeight: "400", color: "#595959" }}
          >
            Sub heading goes here and some additional text here and all other
            text goes here and some and some more additional.
          </div>
        </div>
        <div className="d-flex flex-column" style={{ gap: "10px" }}>
          {Option(
            Discover,
            "Discover Trends",
            "#DFF4FF",
            "#2596D1",
            DiscoverImg
          )}
          {Option(
            CreateShoppingList,
            "Create Shopping List",
            "#FFEEF4",
            "#E4487F",
            CreateShopListImg
          )}
          {Option(
            GetFeedback,
            "Get Feedback",
            "#F5FFEE",
            "#76C33E",
            GetFeedbackImg
          )}
          {Option(
            InviteFriends,
            "Invite Friends",
            "#FFF2EA",
            "#AD6B00",
            inviteFriend
          )}
        </div>
      </div>
      {/* <div
        className="d-flex align-items-center justify-content-end h-100"
        style={{ position: "relative" }}
      > */}
      <div
        style={{
          width: "88vw",
          height: "600px",
          borderRadius: "32px",
          border: `1px solid ${borderColor}`,
          position: "relative",
        }}
      >
        <img
          src={image}
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            objectPosition: "left",
            height: "inherit",
            borderRadius: "32px",
          }}
          loading="lazy"
          alt=""
        />
        <div
          style={{
            position: "absolute",
            left: "-9px",
            bottom: "-10px",
            width: "105%",
            height: "100%",
            borderRadius: "32px",
            backgroundColor: bgrColor,
            zIndex: "-1",
          }}
        />
      </div>
      {/* </div> */}
    </div>
  );
};

export default Page2Mobile;
